const TORQUE_LOCATION_NAME = 'Torque Logistics'
const TORQUE_PROPERTY_KEY = '_fulfilment_location'
const TORQUE_PROPERTY_VALUE = 'TORQUE UK'

function isItemTorqueOnly (itemInventory) {
  const torqueLocation = itemInventory.find(loc => loc.name === TORQUE_LOCATION_NAME)
  return Boolean(torqueLocation) &&
    torqueLocation.available > 0 &&
    itemInventory.every(loc => loc.name === TORQUE_LOCATION_NAME || loc.available <= 0)
}

class ShippingRate extends HTMLElement {
  connectedCallback () {
    this.checkItems()
  }

  async checkItems () {
    const cartItems = await fetch(`${window.Shopify.routes.root}cart.js`)
      .then(res => res.json())
      .then(data => data.items)

    if (cartItems.length <= 1) return

    const response = await fetch(
      `https://aligne-unisian.by-association-only.workers.dev/api/inventory?shop=${Shopify.shop}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(cartItems),
      }
    );

    const { inventory } = await response.json()

    let hasTorqueOnlyItem = false
    let hasNonTorqueOnlyItem = false

    for (const item of cartItems) {
      const itemInventory = inventory[item.variant_id]
      if (!itemInventory) continue

      if (isItemTorqueOnly(itemInventory)) {
        hasTorqueOnlyItem = true
      } else {
        hasNonTorqueOnlyItem = true
      }
    }

    await this.updateFulfilmentLocationProperties(cartItems, inventory)

    const messageEl = this.querySelector('[data-shipping-rate-el="message"]')

    if (!messageEl) return

    const message = this.configureMessage(hasTorqueOnlyItem && hasNonTorqueOnlyItem)

    messageEl.innerHTML = message

    this.setAttribute('aria-hidden', !message)
  }

  async updateFulfilmentLocationProperties (cartItems, inventory) {
    for (const item of cartItems) {
      const itemInventory = inventory[item.variant_id]
      if (!itemInventory) continue

      const isTorqueOnly = isItemTorqueOnly(itemInventory)

      const currentProperties = item.properties || {}
      const isFlagged = currentProperties[TORQUE_PROPERTY_KEY] === TORQUE_PROPERTY_VALUE

      if (isTorqueOnly === isFlagged) continue

      const nextProperties = { ...currentProperties }
      if (isTorqueOnly) {
        nextProperties[TORQUE_PROPERTY_KEY] = TORQUE_PROPERTY_VALUE
      } else {
        delete nextProperties[TORQUE_PROPERTY_KEY]
      }

      try {
        await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: nextProperties,
          }),
        }).then(res => res.json())
      } catch (error) {
        console.warn(`[shipping-rate] Failed to update ${TORQUE_PROPERTY_KEY} for line ${item.key}`, error)
      }
    }
  }

  configureMessage (isSplitShipment) {
    if (isSplitShipment) {
      return window.theme.cart.splitShippingMessage
    }

    return ''
  }
}

if (!customElements.get('shipping-rate')) {
  customElements.define('shipping-rate', ShippingRate)
}
